import type { WalletDebitsTranslations } from "../interfaces/walletDebits";

export const walletDebitsTranslations: WalletDebitsTranslations = {
  page_title: "Débitos em carteiras",
  page_subtitle:
    "Desconte o saldo de um cliente por um envio que a Coloca faz manualmente, fora da plataforma. O valor fica congelado até você registrar o envio com sua referência; cada débito pede seu código de verificação e fica no livro contábil.",
  action_refresh: "Atualizar o histórico",
  action_new: "Novo débito",
  action_retry: "Tentar novamente",
  filter_organization: "Organização",
  filter_all_option: "Todas as organizações",
  filter_all_hint: "Mostrando os débitos de todas as organizações.",
  filter_org_hint: "Mostrando apenas os débitos desta organização.",

  empty_title: "Ainda não há débitos",
  empty_description:
    "Os débitos que você registrar aparecem aqui com a referência do envio e seus comprovantes.",
  col_date: "Data",
  col_organization: "Organização",
  col_amount: "Valor",
  col_concept: "Descrição e nota interna",
  col_external_reference: "Referência do envio",
  col_reference: "Referência",
  col_by: "Feito por",
  col_attachments: "Comprovantes",
  card_note: "Nota interna: {{note}}",
  card_by: "Feito por {{email}}",
  card_external_reference: "Envio: {{reference}}",
  attachments_count: "{{count}} comprovantes",
  attachments_count_one: "1 comprovante",
  attachments_count_none: "Sem comprovantes",

  dialog_title: "Debitar uma carteira",
  dialog_title_review: "Revise o débito",
  dialog_title_done: "Saldo descontado",
  dialog_title_processing: "Descontando o saldo…",
  dialog_description:
    "Desconte o valor do saldo disponível do cliente para um envio manual. Ele fica congelado até você registrar o envio com sua referência, ou cancelar o débito.",
  dialog_description_review:
    "Confira a organização, a carteira, o valor e o meio do envio antes de autorizar.",
  dialog_description_done:
    "O valor ficou congelado na carteira do cliente. Faça o envio e registre aqui sua referência.",
  dialog_description_processing:
    "Estamos descontando o saldo e registrando no livro contábil; pode levar alguns segundos. Não feche esta janela.",
  processing_to: "Envio manual",
  processing_transit_aria:
    "{{amount}} {{currency}} saem da carteira {{currency}} de {{name}} por um envio manual.",
  action_cancel: "Cancelar",
  action_review: "Revisar débito",
  action_back: "Voltar",
  action_confirm: "Autorizar débito",
  action_another: "Fazer outro débito",
  action_close: "Fechar",

  field_organization: "Organização",
  field_organization_required_hint: "Escolha a organização para a qual o envio foi feito.",
  field_organization_hint: "O débito sai de uma carteira desta organização.",
  organization_unknown: "a organização",
  field_wallet: "Carteira",
  field_wallet_hint: "A moeda da carteira é a moeda do débito. Só o saldo disponível pode ser debitado.",
  field_wallet_placeholder: "Escolha uma carteira",
  field_wallet_none: "Esta organização não tem carteiras ativadas, então não há saldo para debitar.",
  field_wallet_option: "{{currency}} · disponível {{balance}}",
  field_wallet_option_empty: "{{currency}} · sem saldo disponível",
  field_wallet_option_inactive: "{{currency}} · {{status}}",
  wallet_frozen: "congelada",
  wallet_closed: "fechada",
  field_amount: "Valor",
  field_amount_hint: "Em {{currency}}. Disponível: {{available}}.",
  field_corridor: "Meio do envio",
  corridor_other: "Outro meio",
  corridor_other_hint: "Sem tarifa: envia-se o valor completo.",
  send_preview_send: "envie",
  send_preview_fees: "Tarifa {{commission}} · impostos {{taxes}}",
  send_preview_hint:
    "O cliente paga a tarifa e os impostos de um envio normal por esse trilho, com as tarifas da sua organização. O débito retira o valor completo e o enviado é o restante.",
  send_preview_needs_amount: "Digite o valor para ver quanto enviar por cada trilho.",
  send_preview_below_fees: "as tarifas superam o valor",
  send_preview_no_fee_configured: "sem tarifas configuradas",
  send_preview_no_corridors: "Não há trilhos de envio configurados para {{currency}}.",
  send_preview_failed: "Não foi possível calcular quanto enviar: {{message}}",
  validation_corridor: "Escolha por onde o envio foi feito.",
  validation_corridor_unpriced: "Aguarde o cálculo da tarifa desse trilho, ou escolha outro meio.",
  review_corridor: "Meio do envio",
  review_commission: "Tarifa",
  review_taxes: "Impostos",
  review_send_by_hand: "Enviado manualmente",
  done_fees: "O que o cliente pagou",
  field_external_reference: "Referência do envio",
  field_external_reference_placeholder: "Ex.: TRF-20261027-004512",
  field_concept: "Descrição",
  field_concept_hint: "O cliente vê no extrato.",
  concept_default: "Envio manual",
  field_note: "Nota interna",
  field_note_hint: "Só a equipe da Coloca vê: por que o envio foi feito manualmente e quem pediu.",
  field_note_placeholder: "Ex.: trilho fora do ar, pedido pelo suporte #519",
  field_attachments: "Comprovantes do envio",

  validation_wallet: "Escolha a carteira a debitar.",
  validation_amount: "Digite um valor maior que zero.",
  validation_amount_precision: "{{currency}} aceita no máximo {{digits}} casas decimais.",
  validation_amount_exceeds: "Maior que o saldo disponível ({{available}}).",
  validation_concept: "Digite a descrição que o cliente verá.",
  validation_note: "Digite uma nota interna para o registro.",

  review_organization: "Organização",
  review_wallet: "Carteira",
  review_wallet_value: "Carteira {{currency}}",
  review_balance_before: "Saldo disponível agora",
  review_amount: "Débito pelo envio",
  review_balance_after: "Saldo depois do débito",
  review_concept: "Descrição (o cliente vê)",
  review_note: "Nota interna",
  review_client_sees:
    "O cliente verá no extrato como um débito da Coloca Payments com o conceito. Ele não recebe e-mail; você e a contabilidade recebem o aviso quando o envio for registrado.",
  review_checkbox: "Conferi a organização, a carteira, o valor e o meio do envio",

  two_factor_required:
    "Para debitar carteiras você precisa da verificação em duas etapas ativa. Ative-a em Configurações e volte.",
  two_factor_description: "Você vai debitar {{amount}} {{currency}} da carteira de {{name}}.",

  unresolved_title: "Um débito ficou sem confirmação",
  unresolved_text:
    "Um débito de {{amount}} ({{reference}}) para esta organização foi autorizado e a resposta não chegou, então não sabemos se foi descontado. Verifique antes de fazer outro.",
  unresolved_text_retry:
    "A resposta não chegou, então não sabemos se este débito foi feito. Verifique, ou autorize de novo: se já tinha sido feito, não é debitado duas vezes.",
  unresolved_action: "Verificar o débito",
  unresolved_pending: "Ainda está sendo processado. Verifique novamente em alguns segundos.",
  unresolved_unknown: "Não conseguimos verificar. Tente de novo em um momento.",
  unresolved_not_placed: "O débito sem confirmação não foi feito. Você já pode fazer o débito.",
  debit_busy:
    "Outra aba está enviando um débito a esta organização. Espere terminar e autorize de novo; nada foi enviado.",
  unresolved_blocked: "Há um débito a esta organização sem confirmação. Verifique antes de fazer outro.",

  done_recovered:
    "O débito sem confirmação foi feito. Este é o registro; verificá-lo não debitou nada de novo.",
  done_replayed:
    "Este débito já tinha sido feito com os mesmos dados. Nada foi debitado de novo nem foram enviados e-mails.",
  done_receipt_label: "Débito",
  done_amount: "Valor descontado",
  done_organization: "Organização",
  done_wallet: "Carteira",
  done_concept: "Descrição",
  done_external_reference: "Referência do envio",
  done_emails_label: "Avisos enviados",
  email_pending: "Enviando o aviso {{who}}.",
  email_sent: "Enviamos o aviso {{who}}.",
  email_failed: "Não conseguimos enviar o aviso {{who}}. O débito foi registrado mesmo assim.",
  email_to_operator: "para o seu e-mail",
  email_to_accounting: "para o e-mail da contabilidade",

  attachments_title: "Comprovantes do envio",
  attachments_empty: "Este débito ainda não tem comprovantes.",
  attachments_uploading: "Enviando os comprovantes…",
  attachments_uploaded: "Comprovantes enviados.",
  attachments_failed:
    "Não conseguimos enviar os comprovantes: {{message}} O débito foi registrado; tente de novo.",
  attachments_retry: "Enviar de novo",
  attachments_upload: "Enviar comprovantes",
  attachments_open: "Abrir {{name}}",
  attachments_unavailable: "Link indisponível",
  attachments_full: "Este débito já tem o máximo de {{max}} comprovantes.",
  attachments_meta: "{{size}} · {{email}}",
  col_status: "Status",
  status_reserved: "Aguardando o envio",
  status_reserved_stale: "Envio pendente há mais de um dia",
  status_sent: "Enviado",
  status_cancelled: "Cancelado",
  member_status: "Status",
  member_status_reserved: "Em andamento",
  member_status_sent: "Concluído",
  member_status_cancelled: "Cancelado: o saldo voltou para sua carteira",
  review_held:
    "O valor fica congelado na carteira do cliente até você registrar o envio ou cancelar o débito. Depois de enviado não pode ser cancelado: corrige-se com uma recarga.",
  review_to_send_by_hand: "A enviar manualmente",
  done_sent_by: "Envio registrado por",
  pending_heading: "Envie {{amount}} e registre o envio",
  pending_text_rail:
    "Faça por {{rail}} pelo banco ou pelo provedor. O valor já está congelado na carteira do cliente: ele não pode usá-lo enquanto isso.",
  pending_text_other:
    "Faça pelo meio combinado. O valor já está congelado na carteira do cliente: ele não pode usá-lo enquanto isso.",
  pending_section_title: "Aguardando o envio",
  pending_section_hint:
    "Saldo congelado cujo envio ainda não foi registrado, o mais antigo primeiro. Abra para registrar o envio ou cancelar.",
  pending_section_failed: "Não foi possível carregar os pendentes: {{message}}",
  send_title: "Registrar o envio",
  send_hint:
    "Depois de fazer o envio, informe sua referência no banco ou no provedor. O comprovante pode ser anexado agora ou depois.",
  send_action: "Registrar envio",
  send_upload_failed:
    "O envio foi registrado, mas os comprovantes não subiram: {{message}} Você pode enviá-los abaixo.",
  cancel_open: "O envio não foi feito: cancelar o débito",
  cancel_title: "Cancelar o débito",
  cancel_hint: "Os {{amount}} voltam ao saldo disponível do cliente e o débito é estornado no extrato.",
  cancel_reason: "Motivo",
  cancel_reason_placeholder: "Ex.: o banco recusou a transferência",
  cancel_confirm: "Cancelar débito",
  cancel_back: "Voltar",
  cancel_two_factor: "Você vai cancelar o débito {{reference}} e devolver o saldo ao cliente.",
  cancelled_text: "Cancelado por {{who}} em {{when}}. Motivo: {{reason}}. O saldo voltou ao cliente.",
  reference_edit: "Editar",
  reference_edit_hint: "A referência anterior fica no histórico.",
  reference_save: "Salvar referência",
  attachments_remove: "Remover",
  attachments_remove_aria: "Remover {{name}}",
  attachments_remove_confirm: "Remover este comprovante? Ele fica guardado e no histórico.",
  attachments_remove_yes: "Sim, remover",
  timeline_title: "Histórico",
  timeline_failed: "Não foi possível carregar o histórico: {{message}}",
  timeline_reserved: "Saldo descontado",
  timeline_sent: "Envio registrado",
  timeline_cancelled: "Débito cancelado",
  timeline_reference_changed: "Referência corrigida",
  timeline_attachments_added: "Comprovantes adicionados",
  timeline_attachment_removed: "Comprovante removido",
  timeline_reference_detail: "{{from}} → {{to}}",
  timeline_two_factor: "com 2FA",
};
